<template>
  <v-card flat>
    <v-card-title class="pa-1 pt-0 pb-2">
      <v-text-field solo dense hide-details ref="scanFocus" v-model="scanNumber" autocomplete="off"
        @change="getRespectiveAdjustmentOrder"
        :placeholder="$t('message.dashboard.scanText')"></v-text-field>
    </v-card-title>
    <v-card-title class="pa-0 pl-2 pr-2">
      <v-btn x-small fab @click="previousList" :disabled="page === 1">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <h5 class="mx-auto">{{ $t('message.dashboard.adjustmentOrders') }}</h5>
      <span class="mr-3 mt-1 text-subtitle-2">{{ getPaginateData }}</span>
      <v-btn x-small fab @click="nextList" :disabled="hasNoNext">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pa-1 pt-0 mt-2">
      <div class="text-center" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <template v-for="(item, index) in listOfOrders">
        <order-item type="adjustment" :key="index" :isList="true" :model="item"></order-item>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      listOfOrders: [],
      loading: false,
      page: 1,
      totalCount: 0,
      totalDbData: 0,
      scanNumber: '',
      perPage: 20,
      hasNoNext: false
    }
  },
  components: {
    'order-item': () => import('@/components/Order/OrderItem')
  },
  mounted () {
    requestAnimationFrame(() => {
      if (this.$refs.scanFocus) {
        this.$refs.scanFocus.focus()
      }
    })
    this.getOrders()
  },
  watch: {
    page (val) {
      this.getOrders()
    }
  },
  computed: {
    getPaginateData () {
      var showFrom = ((this.page - 1) * this.perPage) + 1
      var showTo = (showFrom - 1) + this.listOfOrders.length
      return this.totalDbData > 0 ? `${showFrom} - ${showTo} av ${this.totalDbData}` : ''
    }
  },
  methods: {
    getOrders () {
      this.loading = true
      let pageVal = this.page || 1
      let query = {
        'page': pageVal,
        'rowsperpage': this.perPage
      }
      this.$api.execute('post', 'warehouseorders/get_adjustment_orders', query)
        .then((response) => {
          if (response.data) {
            let { items, total } = response.data
            this.totalDbData = total
            this.totalCount = Math.ceil(total / this.perPage)
            if (this.page === this.totalCount) this.hasNoNext = true
            this.listOfOrders = items
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    previousList () {
      this.page--
      this.checkIsNextEnabled()
    },
    nextList () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.page++
        this.hasNoNext = false
      }
    },
    checkIsNextEnabled () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.hasNoNext = false
      }
    },
    getRespectiveAdjustmentOrder () {
      if (this.scanNumber) {
        this.$api.execute('get', `/warehouseorders/get_order_by_number/${this.scanNumber}/2`)
          .then((response) => {
            if (response && response.data) {
              this.$router.push(`/adjustment_orders/${response.data.id}`)
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.order.noOrderFound') })
            }
          })
      }
    }
  }
}
</script>
